// this is custom history instance from 'history' package for react-router-dom custom router that instantiates the history state

import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
